module.exports = __webpack_public_path__ + "static/img/banner3-2.1f00ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3-2.jpg
// module id = BuLw
// module chunks = 1